import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { ProcessoCadastroService } from "../services/processo-cadastro.service";

@Injectable({
  providedIn: 'root'
})
export class ProcessoCadastroResolver implements Resolve<boolean> {

  constructor(private service: ProcessoCadastroService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.parent.params.id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class ProcessoCadastroFiltersResolver implements Resolve<boolean> {

  constructor(private service: ProcessoCadastroService) { }

  resolve(): Observable<any> {
    return this.service.listFilters();
  }
}